module.exports = __webpack_public_path__ + "static/media/my_view.5a465112.jpg";